import React, { useState } from "react";
import { useForm } from "react-hook-form";
import AppHeader from "../../components/AppHeader";
import AppSidebar from "../../components/AppSidebar";
import PageHeader from "../../components/PageHeader";
import CategoryService from "../../services/CategoryService";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";

const CreateCategory = () => {
    const { register, handleSubmit, reset, formState: { errors } } = useForm();
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const onSubmit = async (data) => {
        setLoading(true);

        try {
            const response = await CategoryService.create({ data });
            if (response.status === 201) {
                toast.success(response?.data?.message);
                reset();
                setTimeout(() => {
                    navigate("/categories");
                }
                , 2000);
            } else {
                console.error("Error in creating category", response);
                toast.error(response?.data?.message);
            }
        } catch (error) {
            console.error("Error in creating category", error);
            toast.error(error?.response?.data.message || error?.message || "Error in creating category");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <AppSidebar />
            <div className="main-content">
                <AppHeader/>
                <div className="container-fluid">
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <PageHeader
                                title="Create Category"
                                button_label1="Back"
                                link_to1="/categories"
                                className1="btn btn-sm btn-primary" 
                            />
                            <div className="row mt-5">
                                <div className="col-12 col-xl-12">
                                    <div className="card">
                                        <div className="card-body">
                                            <form onSubmit={handleSubmit(onSubmit)}>
                                                <div className="mb-3">
                                                    <label className="form-label">Name</label>
                                                    <input
                                                        type="text"
                                                        className={`form-control ${errors.name ? "is-invalid" : ""
                                                            }`}
                                                        {...register("name", {
                                                            required: "Category name is required",
                                                            maxLength: {
                                                                value: 50,
                                                                message: "Category name cannot exceed 50 characters",
                                                            },
                                                        })}
                                                        placeholder="Enter category name"
                                                    />
                                                    {errors.name && (
                                                        <p className="text-danger">{errors.name.message}</p>
                                                    )}
                                                </div>

                                                <div className="mb-3">
                                                    <label className="form-label">Description</label>
                                                    <textarea
                                                        className="form-control"
                                                        {...register("description", {
                                                            maxLength: {
                                                                value: 255,
                                                                message: "Description cannot exceed 255 characters",
                                                            }
                                                        })}
                                                        rows="3"
                                                        placeholder="Enter description"
                                                    ></textarea>
                                                    {errors.description && (
                                                        <p className="text-danger">{errors.description?.message}</p>
                                                    )}
                                                </div>
                                                <div className="text-end">
                                                <button type="submit" className="btn btn-primary" disabled={loading}>
                                                    {loading ? 'Creating...' : 'Create'}
                                                </button>
                                                {loading && (
                                                    <div className="mt-3">
                                                        <div className="spinner-border text-primary" role="status">
                                                            <span className="sr-only">Loading...</span>
                                                        </div>
                                                    </div>
                                                )}
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </>
    );
};

export default CreateCategory;
